import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-871ad7a2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "print",
  class: "document-container"
}
const _hoisted_2 = { class: "document-content" }
const _hoisted_3 = { class: "text-end" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "d-flex justify-content-center w-full" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, "インターネット取引口座開設認証番号のお知らせ")
], -1))
const _hoisted_5 = { class: "content" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "平素は弊社に格別のご高配を賜り、厚く御礼申し上げます。", -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " 下記、インターネット取引口座開設の認証に使用する認証番号をお知らせいたします。 ", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "ご確認頂けますようお願い申し上げます。", -1))
const _hoisted_9 = { class: "fs-4" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " インターネット口座開設の画面にアクセスし、認証番号をご入力ください。 ", -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "今後とも末永くご愛顧を賜りますようお願い申し上げます。", -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-end" }, "敬具", -1))
const _hoisted_13 = /*#__PURE__*/_createStaticVNode("<div class=\"company-info\" data-v-871ad7a2><p data-v-871ad7a2>あい証券株式会社</p><p data-v-871ad7a2>東京都港区六本木1−6−1 泉ガーデンタワー7F</p><p data-v-871ad7a2>第一種・第二種金融商品取引業（関東財務局長（金商）第236号）</p><p data-v-871ad7a2>商品先物取引業（店頭商品デリバティブ取引）</p><p data-v-871ad7a2>（経済産業省 20221207 商第４号、農林水産省指令４新食第2087号）</p><p class=\"associations\" data-v-871ad7a2><span data-v-871ad7a2>加入協会：日本証券業協会<br data-v-871ad7a2></span><span class=\"asso-ml\" data-v-871ad7a2>一般社団法人金融先物取引業協会<br data-v-871ad7a2></span><span class=\"asso-ml\" data-v-871ad7a2>日本商品先物取引協会</span></p><p class=\"contact-info\" data-v-871ad7a2><span data-v-871ad7a2>03-3568-5088（代表）<br data-v-871ad7a2></span><span data-v-871ad7a2>03-3568-5099（FAX）<br data-v-871ad7a2></span><span data-v-871ad7a2>info@isec.jp（Eメールアドレス）</span></p></div>", 1)

import { ref, onMounted, inject } from "vue";
import UserService from "@/projects/tenant/modules/users/services/UserService";

export default /*#__PURE__*/_defineComponent({
  __name: 'JpVerificationCode',
  setup(__props) {

const isLoading = ref(false);
const isGenerated = ref(true);
const code = inject<any>("code");
const verificationDetails = inject<any>("verificationDetails");

const getVerificationCode = async () => {
  isLoading.value = true;
  try {
    const response = await UserService.getMailCode(
      verificationDetails.value.id
    );
    code.value = response;
    isGenerated.value = true;
  } catch (error) {
    console.error(error);
    isGenerated.value = false;
  } finally {
    isLoading.value = false;
  }
};

function getYear(isoString) {
  return new Date(isoString).getFullYear(); // Extracts the year
}

function getMonth(isoString) {
  return new Date(isoString).getMonth() + 1; // Extracts the month
}

function getDay(isoString) {
  return new Date(isoString).getDate(); // Extracts the day
}

onMounted(async () => {
  await getVerificationCode();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(getYear(_unref(verificationDetails).updatedOn)) + "年 " + _toDisplayString(getMonth(_unref(verificationDetails).updatedOn)) + "月 " + _toDisplayString(getDay(_unref(verificationDetails).updatedOn)) + "日 ", 1),
      _createElementVNode("div", null, _toDisplayString(_unref(verificationDetails).info.firstName) + " " + _toDisplayString(_unref(verificationDetails).info.lastName) + " 様 ", 1),
      _hoisted_4,
      _createElementVNode("div", _hoisted_5, [
        _hoisted_6,
        _hoisted_7,
        _hoisted_8,
        _createElementVNode("p", _hoisted_9, "認証番号：" + _toDisplayString(_unref(code)), 1),
        _hoisted_10,
        _hoisted_11,
        _hoisted_12
      ]),
      _hoisted_13
    ])
  ]))
}
}

})